// import React from 'react';
// import {
//   Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, IconButton
// } from '@mui/material';
// import { OutstandingRecord } from '../../types/outstanding';
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import { useHistory } from "react-router-dom";
// interface Props {
//   data: OutstandingRecord[];
//   title: string;
// }

// const OutstandingTable: React.FC<Props> = ({ data, title }) => {
//   if (!data.length) return <Typography>No records found.</Typography>;

//   const history = useHistory();

//   return (
//     <TableContainer component={Paper} sx={{ my: 2 }}>
//       <Typography variant="h6" sx={{ p: 2 }}>{title}</Typography>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Name</TableCell>
//             <TableCell>Balance</TableCell>
//             <TableCell>Last Transaction</TableCell>
//             <TableCell>Details</TableCell>
//             <TableCell>Contact</TableCell>
//             <TableCell>Actions</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {data.map((record) => (
//             <TableRow key={record.id}>
//               <TableCell>{record.name}</TableCell>
//               <TableCell sx={{ color: record.balance < 0 ? 'red' : 'green' }}>
//                 ₦{Math.abs(record.balance).toLocaleString()}
//               </TableCell>
//               <TableCell>{new Date(record.lastTransactionDate).toLocaleDateString()}</TableCell>
//               <TableCell>{record.details || '-'}</TableCell>
//               <TableCell>{record.contactInfo || '-'}</TableCell>
//                 <TableCell>
//                     <IconButton
//                     color="primary"
//                     onClick={() => history.push(`folder/outstandingdetails/${record.id}`)}
//                     >
//                     <VisibilityIcon />
//                     </IconButton>
//                 </TableCell>
//             </TableRow>
//           ))}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default OutstandingTable;


import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Paper, Typography, IconButton, TablePagination, Checkbox
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import { OutstandingRecord } from '../../types/outstanding';
import { useHistory } from 'react-router-dom';
import { OutstandingRecord } from '../../../../types/outstanding';

interface Props {
  // data: OutstandingRecord[];
  // title: string;
  // page: number;
  // rowsPerPage: number;
  // onPageChange: (event: unknown, newPage: number) => void;
  // onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  data: OutstandingRecord[];
  title: string;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  selectedIds: string[];
  onSelectChange: (selected: string[]) => void;
}

const OutstandingTable: React.FC<Props> = ({
  data, title, page, rowsPerPage,
  onPageChange, onRowsPerPageChange, selectedIds, onSelectChange
}) => {
  const history = useHistory();

  const paginatedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleToggle = (id: string) => {
    if (selectedIds.includes(id)) {
      onSelectChange(selectedIds.filter((item) => item !== id));
    } else {
      onSelectChange([...selectedIds, id]);
    }
  };

  const handleSelectAll = (checked: boolean) => {
    if (checked) {
      const allIds = paginatedData.map((r) => r.id);
      onSelectChange([...new Set([...selectedIds, ...allIds])]);
    } else {
      const newSelection = selectedIds.filter(id => !paginatedData.find(r => r.id === id));
      onSelectChange(newSelection);
    }
  };

  const allSelected = paginatedData.every(r => selectedIds.includes(r.id));


  return (
    <TableContainer component={Paper} sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ p: 2 }}>{title}</Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                checked={allSelected}
                onChange={(e) => handleSelectAll(e.target.checked)}
                indeterminate={!allSelected && selectedIds.length > 0}
              />
            </TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Balance</TableCell>
            <TableCell>Last Transaction</TableCell>
            <TableCell>Details</TableCell>
            <TableCell>Contact</TableCell>
            <TableCell>View</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedData.map((record) => (
            <TableRow key={record.id} hover>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedIds.includes(record.id)}
                  onChange={() => handleToggle(record.id)}
                />
              </TableCell>
              <TableCell>{record.name}</TableCell>
              <TableCell sx={{ color: record.legbal < 0 ? 'red' : 'green' }}>
                ₦{Math.abs(record.legbal).toLocaleString()}
              </TableCell>
              <TableCell>{new Date(record.lastTransactionDate).toLocaleDateString()}</TableCell>
              <TableCell>{record.details || '-'}</TableCell>
              <TableCell>{record.contactInfo || '-'}</TableCell>
              <TableCell>
                <IconButton onClick={() => history.push(`/folder/outstandingdetails/${record.id}`)}>
                  <VisibilityIcon fontSize="small" />
                </IconButton>
                  </TableCell>
            </TableRow>
          ))} 
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={data.length}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </TableContainer>
  );
};

export default OutstandingTable;
